import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPReturnActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Return/ReturnBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPReturn"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPReturn"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPReturnActivity)
